(function () {
    'use strict';

    angular
        .module('app')
        .controller('MigrationsController', migrationsController);

    function migrationsController($scope, WebApiService) {
        var model = this;

        model.migrationsRunning = false;

        model.runMigrations = function () {
            model.migrationsRunning = true;

            WebApiService.postJson("/api/migrations/Run").then(function (response) {
                model.log = response;
                model.migrationsRunning = false;
                model.getMigrations();
            }, function (error) {
                model.log = error;
                model.migrationsRunning = false;
                model.getMigrations();
            });
        }

        model.getMigrations = function () {
            WebApiService.get("/api/migrations/Completed").then(function (response) {
                model.migrations = response;
            });
        }

        model.getMigrations();

        $scope.activeState = function (statename) {
            return $state.current.name == statename ? true : false;
        };

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        };

  
        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        };

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        };
    }
})();

